"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEmote = void 0;
const Emote_1 = require("../classes/Emote");
const pixel_pigeon_1 = require("pixel-pigeon");
const definables_1 = require("definables");
const useEmote = (emoteID) => {
    const emote = (0, definables_1.getDefinable)(Emote_1.Emote, emoteID);
    (0, pixel_pigeon_1.emitToSocketioServer)({
        data: {
            emoteID: emote.id,
        },
        event: "world/emote",
    });
};
exports.useEmote = useEmote;
